import horiz from '../assets/showreel_horizpntal_2025.mp4';
import vert from '../assets/showreel_vertical_2025.mp4';
import { Link } from 'react-router-dom';

function Home(){
    return (
        <div className="home"> 
            <div className="main-image">
                <Link to="./works">
                    <video autoPlay loop muted playsInline width="100%" poster={require(`../assets/mobile-poster.webp`)}>
                        <source src={horiz} type="video/mp4" media="(min-width: 850px)" />
                        <source src={vert} type="video/mp4" media="(max-width: 850px)" />
                        Your browser does not support the video tag.
                    </video>
                </Link>
            </div>
        </div>
    );
}
export default Home;